import ExcelJS from "exceljs/dist/exceljs.min.js";
import { displayTagValue } from "./shotTags";
import {
  buildDecoratedShots,
  dataUrlToBase64,
  dateStamp,
  excelExtFromMime,
  getExportHeaders,
} from "./exportShotlistShared";

export async function buildShotlistXlsxBuffer(decorated, lang = "en") {
  const headers = getExportHeaders(lang);

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Shots");

  ws.addRow(headers);
  ws.views = [{ state: "frozen", ySplit: 1 }];

  ws.columns = [
    { width: 10 }, // Scene
    { width: 10 }, // Shot
    { width: 10 }, // Int/Ext
    { width: 28 }, // Location
    { width: 16 }, // Day
    { width: 18 }, // ShotSize
    { width: 18 }, // Angle
    { width: 10 }, // LensMm
    { width: 22 }, // Focus
    { width: 22 }, // Framing
    { width: 18 }, // Movement
    { width: 22 }, // Lights
    { width: 12 }, // Duration
    { width: 40 }, // Description
    { width: 12 }, // Ratio
    { width: 16 }, // Color format
    { width: 18 }, // Image
    { width: 60 }, // ScriptText
    { width: 10 }, // Master
  ];

  const IMAGE_COL = 17;

  for (const r of decorated || []) {
    ws.addRow([
      r.sceneLabel ?? r.sceneIdx,
      r.shotNumber,
      r.intExt,
      r.location,
      r.timeOfDay,
      displayTagValue("shotSize", r.shotSize, lang),
      displayTagValue("angle", r.angle, lang),
      r.lensMm,
      displayTagValue("focus", r.focus, lang),
      displayTagValue("framing", r.framing, lang),
      displayTagValue("movement", r.movement, lang),
      r.lights,
      r.durationSec,
      r.description,
      r.ratioLabel,
      r.colorLabel,
      "",
      r.scriptText,
      r.isMaster ? "MASTER" : "",
    ]);
  }

  for (let i = 0; i < (decorated || []).length; i++) {
    const r = decorated[i];
    if (!r.imageDataUrl) continue;

    const excelExt = excelExtFromMime(r.imageType);
    if (!excelExt) continue;

    const base64 = dataUrlToBase64(r.imageDataUrl);
    if (!base64) continue;

    const imageId = wb.addImage({ base64, extension: excelExt });
    const excelRow = i + 2;
    ws.getRow(excelRow).height = 70;

    ws.addImage(imageId, {
      tl: { col: IMAGE_COL - 1 + 0.1, row: excelRow - 1 + 0.15 },
      ext: { width: 120, height: 65 },
      editAs: "oneCell",
    });
  }

  return wb.xlsx.writeBuffer();
}

export async function buildShotlistXlsx({
  shots,
  scenes,
  scriptText,
  lang = "en",
  baseName = "shotlist",
  shotPrefixMode,
  shotFrameFormat,
}) {
  const { y, m, d } = dateStamp();
  const decorated = buildDecoratedShots({
    shots,
    scenes,
    scriptText,
    lang,
    shotPrefixMode,
    shotFrameFormat,
  });

  const buf = await buildShotlistXlsxBuffer(decorated, lang);
  const filename = `${baseName}_shotlist_${y}-${m}-${d}.xlsx`;
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return { filename, blob, buffer: buf, decorated };
}
